export default (theme) => ({
  multipleCheckboxesSelect: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  checkboxLabel: {
    color: theme.palette.font.main,
  },
  activeCheckboxLabel: {
    color: '#000000',
  },
});
